import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Gérer les carrousels")
], -1)
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body pt-0" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-row" }

import DataTable from "primevue/datatable";
import {ref, onMounted, computed, watch} from 'vue';
import Button from "primevue/button";
import Column from "primevue/column";
import router from "@/router";
import swal from "@/_helpers/swal";
import InputSwitch from "primevue/inputswitch";
import {changeStateCarousel, deleteCarousel, fetchCarousel} from "@/_services/homepage/carousel";
import {ICarousel} from "@/models/homepage/ICarousel";
import {useRoute} from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselList',
  setup(__props) {

const carousel = Array<ICarousel>();
const tableData = ref<Array<ICarousel>>(carousel);
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const totalRecords = ref<number>(0);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const page = ref<number>(1);
const modeSortable = ref<boolean>(false);
const defaultsSort = {
    fieldLabel: "order[createdAt]",
    fieldValue: "desc",
};
const route = useRoute()
const type = computed(() => route.meta?.type as string | undefined)


onMounted(async () => {
    await populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});

watch(() => route.meta.type, () => {
    populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
    isLoading.value = true;
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchCarousel(
        itemsPerPage,
        page,
        criteria,
        sort,
        type.value
    );
    totalRecords.value = totalRecordsDt.value;
    tableData.value = tableDataDt.value;
    isLoading.value = loadingDt.value;
};

async function onPaginate(e) {
    rows.value = e.rows;
    populateDatatable(e.rows, e.page + 1, criteria.value, defaultsSort);
}

const onSort = (e) => {
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, criteria.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
    }
};

const changeState = async (uuid: string, isActive: boolean) => {
    let currentStateBeforeSave = !isActive;
    const confirmationMessage = currentStateBeforeSave
        ? "Êtes-vous sûr de vouloir désactiver ce carrousel ?"
        : "Êtes-vous sûr de vouloir activer ce carrousel ?";
    const result = await swal.confirm(confirmationMessage);
    if (result.isConfirmed) {
        await changeStateCarousel(uuid, isActive);
        const successMessage = isActive
            ? "Vous venez d'activer un carrousel."
            : "Vous venez de désactiver un carrousel.";

        swal.success("Opération réussie !", successMessage);
    }
    populateDatatable(
        rows.value,
        page.value,
        "" != criteria.value ? criteria.value : ""
    );
};

const onDelete = (data: ICarousel) => {
    swal
        .confirm("Êtes vous sur de vouloir supprimer ?")
        .then((result) => {
            if (result.isConfirmed) {
                deleteCarousel(data.uuid).then((result) => {
                    swal.success("succés !", "Suppression effectuée avec succès");
                    populateDatatable(
                        rows.value,
                        page.value,
                        "" != criteria.value ? criteria.value : ""
                    );
                });
            }
        });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        label: "Ajouter un carrousel",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (type.value == 'login' ? _unref(router).push({ name: 'addCarouselLogin' }) : _unref(router).push({ name: 'addCarousel' }))),
        icon: "pi pi-plus",
        class: "button-add"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        value: tableData.value,
        paginator: true,
        rows: rows.value,
        removableSort: "",
        loading: isLoading.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: [10, 25, 100],
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
        onPage: _cache[1] || (_cache[1] = ($event: any) => (onPaginate($event))),
        onSort: _cache[2] || (_cache[2] = ($event: any) => (onSort($event)))
      }, {
        empty: _withCtx(() => [
          _createTextVNode("Aucun produit ne correspond à votre recherche")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Column), {
              field: "vignette",
              header: "Miniature"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.imageWeb)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: slotProps.data.imageWeb.url,
                      class: "w-14"
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "position",
              header: "Position"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.position), 1)
              ]),
              _: 1
            }),
            (type.value == 'login')
              ? (_openBlock(), _createBlock(_unref(Column), {
                  key: 0,
                  field: "domaine",
                  header: "Platforme"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("span", null, _toDisplayString(slotProps.data.domaine), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(Column), {
              field: "action",
              header: "Action"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-pencil",
                    class: "p-edition",
                    style: {"margin-right":"0.5em"},
                    title: "Éditer",
                    onClick: ($event: any) => (type.value == 'login' ? _unref(router).push({ name: 'editCarouselLogin', params: { uuid: slotProps.data.uuid } }) : _unref(router).push({ name: 'editCarousel', params: { uuid: slotProps.data.uuid } }))
                  }, null, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-trash",
                    class: "p-button-danger",
                    style: {"margin-right":"0.5em"},
                    title: "supprimer",
                    onClick: ($event: any) => (onDelete(slotProps.data))
                  }, null, 8, ["onClick"]),
                  _createVNode(_unref(InputSwitch), {
                    modelValue: slotProps.data.active,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.active) = $event),
                    "input-id": slotProps.data.uuid,
                    onInput: ($event: any) => (changeState(slotProps.data.uuid, slotProps.data.active))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "input-id", "onInput"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "totalRecords", "currentPage"])
    ])
  ], 64))
}
}

})